import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {observable, action, computed} from 'mobx';
import { Grid, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, List, ListItem, ListItemText, Fab, Typography, Tooltip, IconButton } from '@material-ui/core';
import AuthStore from 'src/stores/AuthStore';
import KlientStore from 'src/stores/KlientStore';
import SearchIcon from '@material-ui/icons/Search';
import Klient from 'src/models/Klient';
import removeAccents from 'remove-accents';
import AddIcon from '@material-ui/icons/Add';

export interface IClientSelectionDialogProps {
    open;
    onClose;
    onSelect;
    onNewSelect?;
    title: string;
    klientStore?: KlientStore;
}

@inject('klientStore')
@observer
class ClientSelectionDialog extends React.Component<IClientSelectionDialogProps>{

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    @observable private filterText: string = "";

    @computed private get filteredItems(): Klient[] {
        const retVal = this.props.klientStore.klients.filter((klient: Klient) => {
            const name: string = this.replaceDiacritics((klient.jmeno + ' ' + klient.prijmeni).toLowerCase());
            const filter: string = this.replaceDiacritics(this.filterText).toLowerCase();
            if(name.includes(filter)) {
                return true;
            }
            return false;
        }).slice(0, 4);
        return retVal;
    }

    private replaceDiacritics(text: string) {
        return removeAccents(text);
    }

    public render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="add-client-dialog">
                <DialogTitle id="add-client-dialog">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <TextField
                                id="input-with-icon-textfield"
                                label="Hledejte"
                                value={this.filterText}
                                onChange={this.handleChange('filterText')}
                                InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                }} />
                        </Grid>
                        <Grid item xs={12}>
                            {this.filteredItems.length > 0 ? (
                            <List>
                                {this.filteredItems.map(it => (
                                    <ListItem onClick={this.props.onSelect(it)} button>
                                        <ListItemText primary={it.jmeno + ' ' + it.prijmeni} secondary={it.ulice + ', ' + it.mesto} />
                                    </ListItem>
                                ))}
                            </List>):(
                                <div/>
                            )}
                            {this.filteredItems.length < 1 && this.props.onNewSelect == null ? (
                                <div>Žádný klient nenalezen</div>
                                ) : (<div />)}
                            {this.filteredItems.length < 1 && this.props.onNewSelect != null ? (
                                <div style={{display:'flex', alignItems: 'center'}}>
                                    <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                        Žádný klient nenalezen
                                    </Typography>
                                    <Tooltip title="Přidat klienta" aria-label="Přidat klienta">
                                        <Button variant="contained" color="primary" aria-label="Přidat klienta" onClick={this.props.onNewSelect}>
                                            Vytvořit?
                                            <AddIcon />
                                        </Button>
                                    </Tooltip>
                                </div>
                                ) : (<div />)}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default ClientSelectionDialog;



// WEBPACK FOOTER //
// ./src/components/ClientSelectionDialog.tsx